import { toast } from "react-toastify";

export default function handleInvalidateError(error) {
  toast.error("Something went wrong with cache");
  console.error(error);
}
